import {
  Input,
  InputProps,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/input";
import { Button } from "@chakra-ui/react";
import React, { useState } from "react";
import { CheckIcon } from "../../../styles/icons";
import { BaseFieldProps, FieldWrapper } from "../FieldWrapper/FieldWrapper";

interface PasswordFieldProps extends BaseFieldProps {
  isValid?: boolean;
}

export const PasswordField = ({
  name,
  label,
  id,
  helperText,
  isValid,
  infoText,
  ...inputProps
}: PasswordFieldProps & InputProps) => {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      helperText={helperText}
      infoText={infoText}
    >
      {({ field }) => {
        return (
          <InputGroup shadow="sm">
            <Input
              {...field}
              value={field.value == null ? "" : field.value}
              backgroundColor="white"
              {...inputProps}
              type={show ? "text" : "password"}
            />
            <InputRightElement width="4.5rem" h="100%">
              <Button size="xs" onClick={handleClick}>
                {show ? "Hide" : "Show"}
              </Button>
            </InputRightElement>
          </InputGroup>
        );
      }}
    </FieldWrapper>
  );
};
